import { useCardMainMedia } from '@/hooks/cards/useCards';
import { SpeciesAttributes, StrapiEntry } from '@/lib/apiTypes';
import cn from '@/lib/cs';
import ExpertIcon from '@/components/Icon/ExpertIcon';
import RecorderIcon from '@/components/Icon/RecorderIcon';
import useSpecies from '@/hooks/species/useSpecies';

const CollectionCardBadges = ({
	species,
	alignment = 'top',
}: {
	species: StrapiEntry<SpeciesAttributes>;
	alignment?: 'top' | 'side';
}) => {
	const { isUserAudioAvailable } = useCardMainMedia(species.id, ['audio']);
	const { getSpeciesSupportsAudioRecognition } = useSpecies();

	return (
		<div
			className={cn(
				'absolute -start-0.5 flex gap-0.5',
				alignment === 'top' ? '-top-0.5' : 'flex-col -bottom-0.5'
			)}
		>
			{species.attributes.level === 'expert' && (
				<div
					className="shrink-0 rounded-full bg-accent p-1 text-accentCompat"
					title="Expertsoort"
				>
					<ExpertIcon className="size-6 -rotate-6 lg:size-6" />
					<p className="sr-only">Expertsoort</p>
				</div>
			)}
			{getSpeciesSupportsAudioRecognition(species.id) && (
				<div
					className={`shrink-0 rounded-full p-1 ${
						isUserAudioAvailable
							? 'bg-white text-primary'
							: 'bg-secondary text-white'
					}`}
					title="Expertsoort"
				>
					<RecorderIcon className="size-6 -rotate-2 lg:size-6" />
					<p className="sr-only">Geluid verzameld</p>
				</div>
			)}
		</div>
	);
};

export default CollectionCardBadges;
